export const state = {
  cashTypes: [],
  FullCashTypes: [],
};
export const mutations = {
  SaveCashTypes(state, types) {
    // state.tokenID = token;
    if (types.length > 0) {
      // localStorage.setItem("Nocalacagaha", types);
      state.FullCashTypes = [];
      state.cashTypes = [];
      state.FullCashTypes = types;
      // console.log(types.length);
      types.forEach(element => {
        state.cashTypes.push({
          text: element.Cashcode + "(" + element.CashSypol + ")",
          value: element.Cashcode,
        });
      });
    }
  },
};

export const getters = {
  GetCashTypes(state) {
    return state.cashTypes;
  },
  CashSigns(state) {
    // console.log(state);
    return state.FullCashTypes;
  },
  LocalCurrencyGetter(state) {
    if (!state.FullCashTypes.length)
      return [{ CashName: "", CashSypol: "", Cashcode: "" }];
    return state.FullCashTypes.filter(val => {
      return val.CashName === "Home";
    });
  },
};
